__turbopack_context__.v({
  "chevronIcon": "TechnicalData-module-scss-module__u5yFGq__chevronIcon",
  "column": "TechnicalData-module-scss-module__u5yFGq__column",
  "container": "TechnicalData-module-scss-module__u5yFGq__container",
  "divider": "TechnicalData-module-scss-module__u5yFGq__divider",
  "expandButton": "TechnicalData-module-scss-module__u5yFGq__expandButton",
  "expandWrapper": "TechnicalData-module-scss-module__u5yFGq__expandWrapper",
  "fadeGradient": "TechnicalData-module-scss-module__u5yFGq__fadeGradient",
  "fadeOverlay": "TechnicalData-module-scss-module__u5yFGq__fadeOverlay",
  "galletSection": "TechnicalData-module-scss-module__u5yFGq__galletSection",
  "grid": "TechnicalData-module-scss-module__u5yFGq__grid",
  "gridWrapper": "TechnicalData-module-scss-module__u5yFGq__gridWrapper",
  "header": "TechnicalData-module-scss-module__u5yFGq__header",
  "heading": "TechnicalData-module-scss-module__u5yFGq__heading",
  "item": "TechnicalData-module-scss-module__u5yFGq__item",
  "itemLabel": "TechnicalData-module-scss-module__u5yFGq__itemLabel",
  "itemValue": "TechnicalData-module-scss-module__u5yFGq__itemValue",
  "items": "TechnicalData-module-scss-module__u5yFGq__items",
  "loadMoreButton": "TechnicalData-module-scss-module__u5yFGq__loadMoreButton",
  "loadMoreWrapper": "TechnicalData-module-scss-module__u5yFGq__loadMoreWrapper",
  "panelGrid": "TechnicalData-module-scss-module__u5yFGq__panelGrid",
  "panelInner": "TechnicalData-module-scss-module__u5yFGq__panelInner",
  "panelItem": "TechnicalData-module-scss-module__u5yFGq__panelItem",
  "panelItemLabel": "TechnicalData-module-scss-module__u5yFGq__panelItemLabel",
  "panelItemValue": "TechnicalData-module-scss-module__u5yFGq__panelItemValue",
  "panelItems": "TechnicalData-module-scss-module__u5yFGq__panelItems",
  "panelSection": "TechnicalData-module-scss-module__u5yFGq__panelSection",
  "panelSectionTitle": "TechnicalData-module-scss-module__u5yFGq__panelSectionTitle",
  "section": "TechnicalData-module-scss-module__u5yFGq__section",
  "sectionTitle": "TechnicalData-module-scss-module__u5yFGq__sectionTitle",
  "tablistWrap": "TechnicalData-module-scss-module__u5yFGq__tablistWrap",
  "truncated": "TechnicalData-module-scss-module__u5yFGq__truncated",
  "visuallyHidden": "TechnicalData-module-scss-module__u5yFGq__visuallyHidden",
  "withBackground": "TechnicalData-module-scss-module__u5yFGq__withBackground",
});
